import React from 'react';
import {
  Box,
  Typography,
  Button,
  Container,
  Paper,
  IconButton,
} from '@mui/material';
import {
  Cookie as CookieIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import './CookieBanner.css';

const CookieBanner = ({ onAcceptAll, onRejectAll, onCustomize }) => {
  return (
    <Paper className="cookie-banner" elevation={8}>
      <Container maxWidth="lg">
        <Box className="cookie-banner-content">
          <Box className="cookie-banner-info">
            <CookieIcon className="cookie-banner-icon" />
            <Box className="cookie-banner-text">
              <Typography variant="h6" className="cookie-banner-title">
                Nous utilisons des cookies
              </Typography>
              <Typography variant="body2" className="cookie-banner-description">
                Mission Sport utilise des cookies pour améliorer votre expérience,
                analyser le trafic et personnaliser le contenu. En continuant,
                vous acceptez notre utilisation des cookies.
              </Typography>
            </Box>
          </Box>
          
          <Box className="cookie-banner-actions">
            <Button
              variant="text"
              size="small"
              onClick={onRejectAll}
              className="cookie-banner-button cookie-banner-button-reject"
            >
              Refuser
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={onCustomize}
              className="cookie-banner-button cookie-banner-button-customize"
            >
              Personnaliser
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={onAcceptAll}
              className="cookie-banner-button cookie-banner-button-accept"
            >
              Accepter tout
            </Button>
          </Box>
        </Box>
      </Container>
    </Paper>
  );
};

export default CookieBanner;